import React from 'react';
import Heading from '../../Heading';
import { classes } from '../MarketingLayout.st.css.js';
import { isString } from '../../utils/StringUtils';
import { MARKETING_LAYOUT_TITLE } from '../dataHooks';
import { SIZES } from '../constants';
import PropTypes from 'prop-types';
const Title = ({ children, appearance }) => (React.createElement("div", { className: classes.title }, isString(children) ? (appearance === SIZES.tiny ? (React.createElement("div", { "data-hook": MARKETING_LAYOUT_TITLE }, children)) : (React.createElement(Heading, { dataHook: MARKETING_LAYOUT_TITLE, appearance: appearance }, children))) : (React.createElement("div", { "data-hook": MARKETING_LAYOUT_TITLE }, children))));
Title.propTypes = {
    children: PropTypes.node,
    appearance: PropTypes.string,
};
export default Title;
//# sourceMappingURL=Title.js.map